import { IOption } from '@app/core/clinical-trials';

export enum LABORATORY_TYPES {
  General = 'GEN',
  Micro = 'MIC',
}

export const laboratoryTypes: IOption[] = [
  {
    id: LABORATORY_TYPES.General,
    description: 'General',
  },
  {
    id: LABORATORY_TYPES.Micro,
    description: 'Microbiología',
  },
];

// ioption plus demograpphic boolean
export interface IOptionWithDemographic extends IOption {
  demographic: boolean;
}

export const fieldOptions: IOptionWithDemographic[] = [
  {
    id: 'pa.SKU_PACIENTE',
    description: 'QUERY.PA_SKU_PACIENTE',
    demographic: true,
  },
  {
    id: 'i.NUM_PETICION',
    description: 'QUERY.I_NUM_PETICION',
    demographic: true,
  },
  {
    id: 'i.FECHA_PETICION_DT',
    description: 'QUERY.I_FECHA_PETICION_DT',
    demographic: true,
  },
  {
    id: 'i.FECHA_EMISION_DT',
    description: 'QUERY.I_FECHA_EMISION_DT',
    demographic: true,
  },
  { id: 'i.FECHA_CITA', description: 'QUERY.I_FECHA_CITA', demographic: true },
  {
    id: 'i.FECHA_EXTRACCION',
    description: 'QUERY.I_FECHA_EXTRACCION',
    demographic: true,
  },
  {
    id: 'i.FECHA_REGISTRO',
    description: 'QUERY.I_FECHA_REGISTRO',
    demographic: true,
  },
  {
    id: 'i.FECHA_RECEPCION',
    description: 'QUERY.I_FECHA_RECEPCION',
    demographic: true,
  },
  {
    id: 'i.MOTIVO_SOLICITUD',
    description: 'QUERY.I_MOTIVO_SOLICITUD',
    demographic: true,
  },
  {
    id: 'tp.DESC_L_TIPO_PETICION',
    description: 'QUERY.I_DESC_L_TIPO_PETICION',
    demographic: true,
  },
  { id: 'i.URGENTE', description: 'QUERY.I_URGENTE', demographic: true },
  { id: 'i.INFO_1', description: 'QUERY.I_INFO_1', demographic: true },
  { id: 'i.INFO_2', description: 'QUERY.I_INFO_2', demographic: true },
  { id: 'i.INFO_3', description: 'QUERY.I_INFO_3', demographic: true },
  { id: 'i.INFO_4', description: 'QUERY.I_INFO_4', demographic: true },
  { id: 'i.INFO4_DT', description: 'QUERY.I_INFO4_DT', demographic: true },
  { id: 'i.INFO_5', description: 'QUERY.I_INFO_5', demographic: true },
  { id: 'i.INFO_6', description: 'QUERY.I_INFO_6', demographic: true },
  { id: 'i.INFO_7', description: 'QUERY.I_INFO_7', demographic: true },
  { id: 'i.INFO_8', description: 'QUERY.I_INFO_8', demographic: true },
  { id: 'i.INFO_9', description: 'QUERY.I_INFO_9', demographic: true },
  { id: 'i.INFO_10', description: 'QUERY.I_INFO_10', demographic: true },
  { id: 'i.ATTRIB1', description: 'QUERY.I_ATTRIB1', demographic: true },
  { id: 'i.ATTRIB2', description: 'QUERY.I_ATTRIB2', demographic: true },
  { id: 'i.ATTRIB3', description: 'QUERY.I_ATTRIB3', demographic: true },
  { id: 'i.ATTRIB4', description: 'QUERY.I_ATTRIB4', demographic: true },
  { id: 'i.ATTRIB5', description: 'QUERY.I_ATTRIB5', demographic: true },
  {
    id: 'i.MIKROATTRIB2',
    description: 'QUERY.I_MIKROATTRIB2',
    demographic: true,
  },
  {
    id: 'i.MIKROATTRIB3',
    description: 'QUERY.I_MIKROATTRIB3',
    demographic: true,
  },
  {
    id: 'i.MIKROATTRIB4',
    description: 'QUERY.I_MIKROATTRIB4',
    demographic: true,
  },
  {
    id: 'i.MIKROATTRIB5',
    description: 'QUERY.I_MIKROATTRIB5',
    demographic: true,
  },
  {
    id: 'i.ADICIONAL1INFORMES',
    description: 'QUERY.I_ADICIONAL1INFORMES',
    demographic: false,
  },
  {
    id: 'i.ADICIONAL2INFORMES',
    description: 'QUERY.I_ADICIONAL2INFORMES',
    demographic: false,
  },
  {
    id: 'd.FECHA_METODO_DT',
    description: 'QUERY.D_FECHA_METODO_DT',
    demographic: false,
  },
  {
    id: 'd.FECHA_RESULTADO',
    description: 'QUERY.D_FECHA_RESULTADO',
    demographic: false,
  },
  {
    id: 'd.FECHA_VALIDACION_DT',
    description: 'QUERY.D_FECHA_VALIDACION_DT',
    demographic: false,
  },
  {
    id: 'd.FECHA_IMPRESION',
    description: 'QUERY.D_FECHA_IMPRESION',
    demographic: false,
  },
  { id: 'd.RESULTADO', description: 'QUERY.D_RESULTADO', demographic: false },
  {
    id: 'd.TIPO_REGISTRO',
    description: 'QUERY.D_TIPO_REGISTRO',
    demographic: false,
  },
  { id: 'd.FACTURABLE', description: 'QUERY.D_FACTURABLE', demographic: false },
  {
    id: 'd.DETERMINACIONES_URGENTE',
    description: 'QUERY.D_DETERMINACIONES_URGENTE',
    demographic: false,
  },
  { id: 'd.RESCUANTI', description: 'QUERY.D_RESCUANTI', demographic: false },
  { id: 'd.PATOLOGIA', description: 'QUERY.D_PATOLOGIA', demographic: false },
  {
    id: 'd.DETERMINACIONES_ADICIONAL1',
    description: 'QUERY.D_DETERMINACIONES_ADICIONAL1',
    demographic: false,
  },
  {
    id: 'd.VISIBILIDAD',
    description: 'QUERY.D_VISIBILIDAD',
    demographic: false,
  },
  {
    id: 'an.DESC_L_ANALIZADOR',
    description: 'QUERY.AN_DESC_L_ANALIZADOR',
    demographic: false,
  },
  {
    id: 'm.DESC_L_METODO',
    description: 'QUERY.M_DESC_L_METODO',
    demographic: false,
  },
  {
    id: 'm.SKU_ORI_MASTER_METODO',
    description: 'QUERY.M_SKU_ORI_MASTER_METODO',
    demographic: false,
  },
  {
    id: 'a.DESC_L_AREAS',
    description: 'QUERY.A_DESC_L_AREAS',
    demographic: false,
  },
  { id: 'd.RESULTADO2', description: 'QUERY.D_RESULTADO2', demographic: false },
  { id: 'd.RESCUANTI2', description: 'QUERY.D_RESCUANTI2', demographic: false },
  {
    id: 'pa.NOM_PACIENTE',
    description: 'QUERY.PA_NOM_PACIENTE',
    demographic: true,
  },
  { id: 'pa.APELLIDOS', description: 'QUERY.PA_APELLIDOS', demographic: true },
  { id: 'pa.FECHA_NAC', description: 'QUERY.PA_FECHA_NAC', demographic: true },
  { id: 'pa.SEXO', description: 'QUERY.PA_SEXO', demographic: true },
  {
    id: 'pa.PACIENTE_COD_1',
    description: 'QUERY.PA_PACIENTE_COD_1',
    demographic: true,
  },
  {
    id: 'pa.PACIENTE_COD_2',
    description: 'QUERY.PA_PACIENTE_COD_2',
    demographic: true,
  },
  {
    id: 'pa.PACIENTE_COD_3',
    description: 'QUERY.PA_PACIENTE_COD_3',
    demographic: true,
  },
  { id: 'pa.DOMICILIO', description: 'QUERY.PA_DOMICILIO', demographic: true },
  {
    id: 'pa.CODIGO_POSTAL',
    description: 'QUERY.PA_CODIGO_POSTAL',
    demographic: true,
  },
  { id: 'pa.CIUDAD', description: 'QUERY.PA_CIUDAD', demographic: true },
  { id: 'pa.PAIS', description: 'QUERY.PA_PAIS', demographic: true },
  {
    id: 'pa.PAIS_ORIGEN',
    description: 'QUERY.PA_PAIS_ORIGEN',
    demographic: true,
  },
  { id: 'pa.RAZA', description: 'QUERY.PA_RAZA', demographic: true },
  {
    id: 's.COD_SERVICIO',
    description: 'QUERY.S_COD_SERVICIO',
    demographic: true,
  },
  {
    id: 's.NOMBRE_SERVICIO',
    description: 'QUERY.S_NOMBRE_SERVICIO',
    demographic: true,
  },
  {
    id: 'diag.COD_DIAGNOSTICO',
    description: 'QUERY.DIAG_COD_DIAGNOSTICO',
    demographic: true,
  },
  {
    id: 'diag.DESC_DIAGNOSTICO',
    description: 'QUERY.DIAG_DESC_DIAGNOSTICO',
    demographic: true,
  },
  {
    id: 'diag.DESC_L_DIAGNOSTICO',
    description: 'QUERY.DIAG_DESC_L_DIAGNOSTICO',
    demographic: true,
  },
  {
    id: 'av.DESC_AREAVALIDACION',
    description: 'QUERY.AV_DESC_AREAVALIDACION',
    demographic: false,
  },
  {
    id: 'des.COD_DESTINO',
    description: 'QUERY.DES_COD_DESTINO',
    demographic: true,
  },
  {
    id: 'des.DESC_DESTINO',
    description: 'QUERY.DES_DESC_DESTINO',
    demographic: true,
  },
  {
    id: 'cen.COD_CENTRO',
    description: 'QUERY.CEN_COD_CENTRO',
    demographic: true,
  },
  {
    id: 'cen.DESC_CENTRO',
    description: 'QUERY.CEN_DESC_CENTRO',
    demographic: true,
  },
  {
    id: 'cen.DESC_L_CENTRO',
    description: 'QUERY.CEN_DESC_L_CENTRO',
    demographic: true,
  },
];

export const urgenciesOptions = [
  {
    id: 'S',
    description: 'OPTIONS.YESNO.YES',
  },
  {
    id: 'N',
    description: 'OPTIONS.YESNO.NO',
  },
];

export const genderOptions = [
  {
    id: 'M',
    description: 'OPTIONS.GENDER.M',
  },
  {
    id: 'F',
    description: 'OPTIONS.GENDER.F',
  },
];
